<template>
  <div>
    <b-progress :value="amountSpent" :max="nextLevelAmount"  show-value animated></b-progress>
  </div>
</template>

<script>
export default {
  name: "LevelProgress",
  props: ['amountSpent', 'nextLevelAmount']
}
</script>

<style scoped>

</style>
